import { render, staticRenderFns } from "./musicFacebook.vue?vue&type=template&id=2a637fec&"
import script from "./musicFacebook.vue?vue&type=script&lang=js&"
export * from "./musicFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports